import React, { Suspense } from "react";
import "./App.scss";
import { RoutesPage } from "./routes/routes";
import "rsuite/dist/rsuite.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../src/component/Loader/loader";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Suspense fallback={<Loader />}>
        <RoutesPage />
      </Suspense>
    </div>
  );
}

export default App;
